<template>
  <createContent/>
</template>

<script>
import createContent from '@/components/_authorityservices/_show/showMyServicesDetail.vue'
export default {
  components: {
    createContent
  }
}
</script>
